<template>
  <div>
    <el-dialog
      :title="`${isTaskEdit ? '修改解锁奖品任务' : '添加解锁奖品任务'}`"
      :visible="taskDialog"
      width="840px"
      @close="taskClose"
      v-if="taskDialog"
    >
      <el-form :model="taskForm" label-position="right" class="new-input-box">
        <el-form-item
          label="任务类型:"
          label-width="110px"
          label-position="right"
          required
        >
          <el-select
            v-model="taskForm.taskType"
            style="width: 350px"
            placeholder="请选择任务类型"
            @change="taskTypeChange"
          >
            <el-option
              v-for="item in taskTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="alreadySelectList.includes(item.value)"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="任务条件:"
          label-width="110px"
          label-position="right"
          required
          v-if="taskForm.taskType"
        >
          <!-- 浏览商品、预约商品 -->
          <span v-if="[3,12,13].includes(taskForm.taskType)">
            <span v-if="taskForm.taskType==12">成功预约</span>
            <span v-if="taskForm.taskType==13">成功浏览</span>
            <el-input
              v-model.number="taskForm.taskCondition"
              placeholder="请输入"
              style="width: 130px;margin-left: 4px;"
              @input="
                taskForm.taskCondition = getNumberData(1, $event, 0, 1, 999999)
              "
            ></el-input>
            件商品
          </span>
          <div class="rule_box" v-else-if="taskForm.taskType == 17">
            <jd-tip v-if="taskForm.taskType == 17">
              <div>1、因官方接口限制，POP统计订单实付金额，自营统计订单金额（是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。）；</div>
              <div>2、如设置【购物任务】条件，则活动对象设置必须为会员身份，接口限制非会员无法统计交易数据。</div>
            </jd-tip>
            <div class="rule_box_top">
              所下订单需满足以下条件即可解锁成功（按累计订单统计）
            </div>
            <div class="rule_box_middle">
              <el-form-item label="下单店铺:" required>
                <orderShopCom
                  :venderIds.sync="taskForm.venderIds"
                  :multiShopGoods.sync="multiShopGoods"
                  :sellerSkuList.sync="taskForm.sellerSkuList"
                />
              </el-form-item>
              <el-form-item label="下单时间:" required>
                <span class="label-right">用户在</span>
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="taskForm.orderStartTime"
                    type="datetime"
                    placeholder="选择日期时间"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 185px; font-size: 12px"
                    class="time1"
                    :clearable="false"
                    :picker-options="orderStartPickerOptions"
                  >
                  </el-date-picker>
                  <div class="time_to_text">至</div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="taskForm.orderEndTime"
                    default-time="23:59:59"
                    type="datetime"
                    placeholder="选择日期时间"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 185px; font-size: 12px"
                    class="time2"
                    :clearable="false"
                    :picker-options="orderEndPickerOptions"
                    @change="orderEndTimeChange"
                  >
                  </el-date-picker>
                  <i
                    class="el-icon-circle-close date_icon1"
                    @click="clearOrderTime"
                  ></i>
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                    alt=""
                    class="date_icon2"
                  />
                </div>
                <span class="label-left">期间内下单</span>
              </el-form-item>
              <el-form-item label="金额统计类型:" required>
                <el-radio-group
                  v-model="taskForm.orderPaymentType"
                >
                  <el-radio :label="1">
                    <span>订单金额（后台价）</span>
                    <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                  <el-radio :label="0" v-if="!isVenderType">
                    <span>用户应付金额</span>
                    <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                  <el-radio :label="2" v-if="!isVenderType">
                    <span>用户实付金额</span>
                    <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- <el-form-item label="金额统计类型:" required>
                <el-radio-group
                  v-model="taskForm.countType"
                >
                  <el-radio :label="0" :disabled="isVenderType"> 实付金额 </el-radio>
                  <el-radio :label="1"> 订单金额 </el-radio>
                </el-radio-group>
                <div style="color: red">
                  注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。
                </div>
              </el-form-item> -->
              <el-form-item label="商品要求:" required>
                <!-- <el-radio-group
                  v-model="taskForm.skuType"
                  @change="filterTypeChange"
                >
                  <el-radio :label="0">全部</el-radio>
                  <el-radio :label="1">指定商品</el-radio>
                  <el-radio :label="2">排除商品</el-radio>
                </el-radio-group>
                <jd-button
                  type="default"
                  :style="{
                    margin: ' 0 0px 0 15px',
                  }"
                  @click="exposureProducts"
                  :disabled="taskForm.skuType == 0"
                >
                  {{
                    taskForm.selectGoodsFilterArr.length != ""
                      ? "已选" + taskForm.selectGoodsFilterArr.length + "个"
                      : "+添加"
                  }}
                </jd-button> -->
                  <productReqCom
                    :filterType.sync="taskForm.skuType"
                    :venderIds.sync="taskForm.venderIds"
                    :sellerSkuList.sync="taskForm.sellerSkuList"
                    :multiShopGoods.sync="multiShopGoods"
                    :limitNum="goodsLimit"
                    addGoodText="已选"
                  />
              </el-form-item>
              <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                <el-radio-group
                  v-model="taskForm.mergeOrder"
                >
                  <el-radio :label="false">否</el-radio>
                  <el-radio :label="true">是</el-radio>
                </el-radio-group>
                <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
              </el-form-item>
              <!-- 指定商品规则：仅商品要求为"指定商品"时展示，0=整单计算 1=仅统计指定商品金额和件数 -->
              <el-form-item label="指定商品规则:" v-if="taskForm.orderPaymentType==1&&taskForm.skuType == 1">
                <el-select style="width: 280px;" v-model="taskForm.statsSkuType" placeholder="">
                  <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                  <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单状态:" required>
                <el-radio-group v-model="taskForm.orderType">
                  <el-radio :label="1">已完成</el-radio>
                  <el-radio :label="0"
                    >已付款（下单付款后即可统计（预售商品需要支付尾款才统计））</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="消费门槛:" required>
                <span class="label-right">订单金额</span>
                <el-input
                  v-model="taskForm.orderStartPayment"
                  @input="
                    taskForm.orderStartPayment = taskForm.orderStartPayment =
                      getNumberData(1, $event, 1, 0)
                  "
                  style="width: 140px"
                  placeholder="请输入"
                ></el-input
                ><span class="label-left label-right">元，且商品件数</span>
                <el-input
                  v-model="taskForm.itemStartCount"
                  @input="
                    taskForm.itemStartCount = getNumberData(
                      1,
                      $event,
                      0,
                      1,
                      999999
                    )
                  "
                  style="width: 140px"
                  placeholder="请输入"
                ></el-input>
                <span class="label-left">件</span>
              </el-form-item>
              <el-form-item label="统计方式:" required>
                <el-radio-group v-model="taskForm.orderCountType">
                  <el-radio :label="1">累计订单</el-radio>
                  <el-radio :label="0">单笔订单</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>

          <span v-else>{{ taskForm.taskCondition }}</span>
        </el-form-item>
        <el-form-item
          label="商品要求:"
          label-width="110px"
          label-position="right"
          v-if="[3, 4,13].includes(taskForm.taskType)"
        >
          <el-checkbox
            :true-label="1"
            :false-label="0"
            v-model="taskForm.skuType"
            >指定商品</el-checkbox
          >
          <el-button
            style="width: 100px; margin-left: 8px"
            @click="exposureProductsFiter"
            :disabled="!taskForm.skuType"
          >
            {{ "已选择" + "(" + taskForm.itemListForFilter.length + "个)" }}
          </el-button>
        </el-form-item>
        <el-form-item
          label="预约商品:"
          label-width="110px"
          required
          v-if="taskForm.taskType == 12"
        >
          <div class="task-wrap">
            <jd-button type="blue" @click="showGoods(100)"
              >选择商品（{{
                taskForm.itemListForFilter.length
              }}/100）</jd-button
            >
            <span class="tip-red label-left"
              >注意：请添加预约商品，非预约商品无法完成任务</span
            >
          </div>
        </el-form-item>
        <el-form-item
          label="历史入会:"
          label-width="110px"
          required
          v-if="taskForm.taskType == 7&&isShowHis"
        >
          <el-radio :label="0" v-model="taskForm.joinMemberType">历史入会用户当做已完成任务处理</el-radio>
          <el-radio :label="1" v-model="taskForm.joinMemberType">历史入会用户当做未完成任务处理，不可参与活动（即仅新入会会员可参与活动）</el-radio>
      </el-form-item>
      </el-form>
      <div slot="footer">
        <jd-button style="margin-right: 8px" @click="taskClose">取消</jd-button>
        <jd-button type="blue" @click="sureTask">确定</jd-button>
      </div>
    </el-dialog>
    <!-- 购买商品-指定购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter"
      ref="selectGo"
      :isShow="selectGoodsStateFilter"
      @close="selectGoodsCloseFilter"
      :selectGoods="taskForm.selectGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      isInteract
    ></selectGoodsMonitor>
    <!-- 商品要求 -->
    <selectGoodsMonitor
      v-if="selectGoods"
      ref="selectGo"
      :isShow="selectGoods"
      @close="selectGoodsClose"
      :selectGoods="taskForm.itemListForFilter"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="isLimit"
      :limitNum="goodsLimit"
      isInteract
    ></selectGoodsMonitor>
  </div>
</template>
<script>
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import orderShopCom from "./multipleStoreSetting/orderShopCom.vue";
import productReqCom from "./multipleStoreSetting/productReqCom.vue";
import { useValidateMultiShopGoods } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
export default {
  name: "",
  components: {
    selectGoodsMonitor,
    orderShopCom,
    productReqCom
  },
  mixins: [],
  props: {
    activityTimeValue: {
      type: Array,
      default: () => [],
    },
    taskDialog: {
      type: Boolean,
      default: false,
    },
    isTaskEdit: {
      type: Boolean,
      default: false,
    },
    taskData: {
      type: Object,
      default: () => ({}),
    },
    taskTypeOptions: {
      type: Array,
      default: () => [],
    },
    selectGoodsList: {
      type: Array,
      default: () => [],
    },
    taskDataLists: {
      type: Array,
      default: () => [],
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
    // 活动详情
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    // 是否自营
    venderType: {
      type: Boolean,
      default: false,
    },
    isShowHis: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isPremissionShow: true,
      selectGoods: false,
      isLimit: false,
      goodsLimit: 100,
      selectGoodsStateFilter: false,
      includeArr: [], //指定商品
      excludeArr: [], //排除商品
      taskForm: {
        activityType: 2,
        taskValidity: 1,
        taskType: "",
        taskCondition: "",
        orderStartTime: "", //下单时间
        orderEndTime: "",
        countType: 0,
        skuType: 0,
        statsSkuType: 0, // 指定商品规则 0:整单计算 1:仅统计指定商品金额和件数
        orderType: 1,
        orderCountType: 1,
        itemStartCount: null,
        orderStartPayment: null,
        itemListForFilter: [], // 商品要求
        selectGoodsFilterArr: [], // 下单-商品要求
        joinMemberType: 0,
        venderIds: [],
        sellerSkuList: [],
        orderPaymentType: 1,
        mergeOrder: false,
      },
      multiShopGoods: [],
      taskDataList: [],
      goodsTypeList: [3, 4,13],
      conditionValue: [3, 4, 12,13], //taskCondion有其他值的类型
      orderStartPickerOptions: {
        disabledDate: (time) => {
          if (this.taskForm.orderEndTime) {
            return (
              time.getTime() >
              new Date(this.taskForm.orderEndTime).valueOf() - 8.64e7
            );
          } else {
            return false;
          }
        },
      },
      // 下单结束时间<=活动结束时间
      orderEndPickerOptions: {
        disabledDate: (time) => {
          return (
            (this.taskForm.orderStartTime &&
              time.getTime() <
                new Date(this.taskForm.orderStartTime).valueOf()) ||
            (this.ruleForm.endTime &&
              time.getTime() > new Date(this.ruleForm.endTime).valueOf()) ||
            (this.ruleForm.timingPrizeTime &&
              time.getTime() >
                new Date(this.ruleForm.timingPrizeTime).valueOf())
          );
        },
      },
    };
  },
  computed: {
    alreadySelectList() {
      let taskTypeList = this.taskDataLists.map((item) => {
        return item.taskType;
      });
      return taskTypeList;
    },
    //权限判断
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
    venderId() {
      // 店铺Id
      return this.$store.getters.loginUserInfo.venderId;
    },
    isVenderType() {
      return this.multiShopGoods.some((item) => item.venderType);
    },
    isPop() {
      return this.multiShopGoods.every((item) => !item.venderType);
    },
  },
  watch: {
    permissions:{
      handler(nVal, oVal) {
        if (nVal.indexOf("hide:interactive:product:offline") != "-1") {
         this.isPremissionShow = false;
        }
      },
      immediate: true,
    },
    // 只选pop店铺
    // isPop(newVal) {
    //   if(newVal) {
    //     this.taskForm.countType = 0
    //   } else {
    //     this.taskForm.countType = 1
    //   }
    // },
    //自营和pop店铺其中一个或只有自营
    isVenderType(newVal) {
      if(newVal) {
        this.taskForm.countType = 1
      } 
      // else {
      //   this.taskForm.countType = 0
      // }
    },
  },
  created() {
    this.initData();
    if (!this.isTaskEdit) {
      if (this.venderType) {
        this.taskForm.countType = 1;
      }
    } else {
      this.taskForm = this.taskData;
      // 指定商品规则兜底：老数据无该字段时默认整单计算
      this.taskForm.statsSkuType = this.taskData.statsSkuType || 0;
     // 购买商品新增下单店铺回显处理
     if (this.taskForm.taskType == 17) {
        this.goodsLimit = 500
        if(this.taskForm.skuType ==1) {
          const isReq = this.taskForm.sellerSkuList.some((item) => {
            return item.itemList&&item.itemList.length>0;
          });
          if (!isReq) {
            const reqList = this.taskForm.sellerSkuList.map((item) => {
              return getTaobaoItemListSku({
                current: 1,
                size: item.skuIds.length,
                skuIds: item.skuIds,
                venderId: item.venderId,
              });
            });
            Promise.all(reqList).then((res) => {
              res.forEach((itemRes, index) => {
                this.taskForm.sellerSkuList[index].itemList = itemRes.data.records;
              });
            });
          }
        }
      } else {
        this.goodsLimit = 100
      }
    }
    this.taskDataList = this.taskDataLists;
  },
  methods: {
    viewMergeLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#")
    },
    initData() {
      this.taskForm.venderIds = this.taskForm.venderIds.length> 0 ? this.taskForm.venderIds : [this.venderId];
      this.taskForm.sellerSkuList = this.taskForm.sellerSkuList&&this.taskForm.sellerSkuList.length> 0 ? this.taskForm.sellerSkuList : [
        {
          venderId: this.venderId,
          skuIds: [],
          itemList: [],
        },
      ];
      this.multiShopGoods = useValidateMultiShopGoods(this, this.taskForm.venderIds);
    },
    // 下单时间
    onOrderTimeChange(time) {
      if (time && time.length) {
        this.taskForm.orderStartTime = time[0];
        this.taskForm.orderEndTime = time[1];
        this.orderTimeArr = time;
      } else {
        this.taskForm.orderStartTime = "";
        this.taskForm.orderEndTime = "";
        this.orderTimeArr = [];
      }
    },
    // 购买商品-商品要求
    filterTypeChange(val) {
      if (val == 0) {
        this.taskForm.selectGoodsFilterArr = [];
      } else if (val == 1) {
        this.taskForm.selectGoodsFilterArr = this.includeArr;
      } else if (val == 2) {
        this.taskForm.selectGoodsFilterArr = this.excludeArr;
      }
    },
    // 购买商品-添加指定商品弹窗
    exposureProducts() {
      this.selectGoodsStateFilter = true;
      if (this.ruleForm.skuType == 1) {
        this.taskForm.selectGoodsFilterArr = this.includeArr;
      } else if (this.ruleForm.skuType == 2) {
        this.taskForm.selectGoodsFilterArr = this.excludeArr;
      }
      this.$nextTick(() => {
        this.$refs.selectGo.handleRightCurrentChange(1);
      });
    },
    // 购买商品-选择指定商品数据回调
    selectGoodsCloseFilter(data) {
      if (data) {
        let isGoods = false;
        data.forEach((item) => {
          if (item.skuStatus != 1) {
            isGoods = true;
          }
        });
        if(this.isPremissionShow){
         if (isGoods) {
           return this.$message.warning("当前所选商品包含下架商品，请重新选择");
         }
        }
        let selectGoodsArr = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          selectGoodsArr.push(fomeVaule);
        });
        if (this.ruleForm.skuType == 1) {
          this.includeArr = selectGoodsArr;
        } else if (this.ruleForm.skuType == 2) {
          this.excludeArr = selectGoodsArr;
        }
        this.taskForm.selectGoodsFilterArr = selectGoodsArr;
      }
      this.selectGoodsStateFilter = false;
    },
    // 商品要求
    exposureProductsFiter() {
      this.isLimit = false;
      this.selectGoods = true;
    },
    //商品要求-数据回调
    selectGoodsClose(data) {
      if (data) {
        let isGoods = false;
        data.forEach((item) => {
          if (item.skuStatus != 1) {
            isGoods = true;
          }
        });
        if(this.isPremissionShow){
         if (isGoods) {
           return this.$message.warning("当前所选商品包含下架商品，请重新选择");
         }
        }
        let selectGoodsArr = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          selectGoodsArr.push(fomeVaule);
        });
        this.taskForm.itemListForFilter = selectGoodsArr;
      }
      this.selectGoods = false;
    },
    // 确认添加任务
    sureTask() {
      if (!this.taskForm.taskType) {
        return this.$message.warning("请选择任务类型");
      }
      // 任务条件
      if (this.conditionValue.includes(this.taskForm.taskType)) {
        if (!this.taskForm.taskCondition) {
          return this.$message.warning("请填写任务条件");
        }
      }

      // 预约商品
      if (this.taskForm.taskType == 12) {
        if (this.taskForm.itemListForFilter.length == 0) {
          return this.$message.warning(`请选择预约商品`);
        }
      }

      if (this.taskForm.taskType == 17) {
        if (!this.taskForm.orderStartTime || !this.taskForm.orderEndTime)
          return this.$message.warning("请选择下单时间");
        // if (
        //   this.taskForm.skuType != 0 &&
        //   !this.taskForm.selectGoodsFilterArr.length
        // )
        //   return this.$message.warning(
        //     this.taskForm.skuType == 2 ? "请选择排除商品" : "请选择指定商品"
        //   );
        if (this.taskForm.skuType == 1) {
          const obj = this.taskForm.sellerSkuList.find((item) => {
            return item.skuIds.length == 0;
          });
          if (obj) {
            const shop = this.multiShopGoods.find((item) => {
              return item.venderId == obj.venderId;
            });
            const skuTypes= {
            1: "指定",
            2: "排除",
          }
            return this.$message.warning(`请选择${shop.shopTitle}的${skuTypes[this.taskForm.skuType]}商品`);
          }
        }
        if (!this.taskForm.itemStartCount && !this.taskForm.orderStartPayment) {
          return this.$message.warning("请填写消费门槛");
        }
      }
      if(this.taskForm.taskType==13) {
        if (this.taskForm.skuType==0) {
          return this.$message.warning(`请勾选指定商品`);
        }
      }
      // 商品
      if (this.goodsTypeList.includes(this.taskForm.taskType)) {
        if (this.taskForm.skuType == 1) {
          if (this.taskForm.itemListForFilter.length == 0) {
            return this.$message.warning(`请选择指定商品`);
          }
        }
      }
      const obj = JSON.parse(JSON.stringify(this.taskForm));
      if(obj.taskType==2||obj.taskType==13) {
        obj.activityType = 1
      }
      if(obj.taskType==13) {
        obj.giveLimit = obj.taskCondition
      }
      // 区分任务模式不同但任务相同的任务
      if (this.isTaskEdit) {
        this.taskDataList.splice(this.currentIndex, 1, obj);
      } else {
        this.taskDataList.push(obj);
      }
      this.$emit("getTaskDataList", this.taskDataList);
      console.log("taskDataList>>", this.taskDataList);
    },
    // 关闭
    taskClose() {
      this.$emit("closeTask");
    },
    // 任务类型change
    taskTypeChange(e) {
      const obj = this.taskTypeOptions.find((item) => item.value == e);
      this.taskForm.taskCondition = obj.taskCondition || "";
      if(e==17) {
        this.goodsLimit = 500
        this.initData();
      } else {
        this.goodsLimit = 100
      }
    },
    // 清空下单时间
    clearOrderTime() {
      this.taskForm.orderStartTime = null;
      this.taskForm.orderEndTime = null;
    },
    // 下单时间
    orderEndTimeChange() {
      if (this.ruleForm.timingPrizeTime) {
        if (
          this.isSameDay(
            this.ruleForm.timingPrizeTime,
            this.taskForm.orderEndTime
          ) &&
          new Date(this.taskForm.orderEndTime).valueOf() >
            new Date(this.ruleForm.timingPrizeTime).valueOf()
        ) {
          this.taskForm.orderEndTime = this.ruleForm.timingPrizeTime;
        }
        return;
      }
      if (this.ruleForm.endTime) {
        if (
          this.isSameDay(this.ruleForm.endTime, this.taskForm.orderEndTime) &&
          new Date(this.taskForm.orderEndTime).valueOf() >
            new Date(this.ruleForm.endTime).valueOf()
        ) {
          this.taskForm.orderEndTime = this.ruleForm.endTime;
        }
      }
    },
    // 判断是否同一天
    isSameDay(date1, date2) {
      // 将日期转换为Date对象
      const d1 = new Date(date1);
      const d2 = new Date(date2);

      // 设置时间为午夜12点（这样可以忽略时分秒）
      d1.setHours(0, 0, 0, 0);
      d2.setHours(0, 0, 0, 0);

      // 比较年月日是否相同
      return d1.getTime() === d2.getTime();
    },
    // 商品弹窗
    showGoods(limit = 100) {
      this.goodsLimit = limit;
      this.isLimit = true;
      this.selectGoods = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.task-tip-wrap {
  margin-bottom: 20px;
}
.task-wrap {
  display: flex;
  align-items: center;
  &-radio {
    margin-right: 10px;
  }
  .time-box {
    display: flex;
    align-items: center;
  }
}

.tip-red {
  color: red;
}

.tip-type {
  margin: -2px 6px;
}
.task-tip {
  background-color: #f8f9fc;
  padding: 20px;
  border-radius: 4px;
}

.w90 {
  width: 60px;
}

.rule_box {
  width: 100%;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  margin-top: 0px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}

.label {
  &-right {
    margin-right: 8px;
  }
  &-left {
    margin-left: 8px;
  }
}
.pd20 {
  padding: 20px;
}
</style>
